import React, { forwardRef } from 'react';

import { useClassnames } from '@lumapps/classnames';
import { Button, ButtonProps } from '@lumapps/lumx/react';

import './index.scss';

const CLASSNAME = 'ask-ai-source-chip';

/**
 * Component to manage the display of ask ai source links.
 */
export const AskAiSourceChip = forwardRef<HTMLButtonElement, ButtonProps>(
    ({ className, children, ...forwardedProps }, ref) => {
        const { block } = useClassnames(CLASSNAME);

        return (
            <Button ref={ref} className={block(undefined, [className])} {...forwardedProps}>
                {children}
            </Button>
        );
    },
);
